import React from 'react';
import Utils from 'lib/Utils';


class AutoResizePage extends React.Component {

  setContentRef = element => {
    if (
      element === null
      || element === undefined
    ) {
      return;
    }
    this.contentRef = element;
  };

  setScreenSize = (screenSize) => {
    this.setState(
      { screenSize }
    );
  }

  setNavBarSize = (updatedNavBarSize) => {
    const {
      navBarSize,
    } = this.state;
    const {
      width,
      height,
    } = updatedNavBarSize;
    if (
      navBarSize.height !== height ||
      navBarSize.width !== width
    ) {
      this.setState(
        {
          navBarSize: {
            height,
            width,
          }
        }
      );
    }
  }

  setContentSize = (contentSize) => {
    this.setState(
      { contentSize }
    );
  }

  updateContentSize = () => {
    const {
      height,
      width,
    } = Utils.getScreenSize();
    const {
      navBarSize,
      screenSize,
    } = this.state;
    if (
      height !== screenSize.height
      || width !== screenSize.width
    ) {
      this.setScreenSize({
        height,
        width,
      });
      this.setState(
        {
          contentHeight: Math.ceil(height) - navBarSize.height,
          contentWidth: Math.ceil(width)  - navBarSize.width,
        }
      );
    }
  }

  render() {
    return (
      <>
      </>
    );
  }
}

export default AutoResizePage;
